import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import useSEO from "@/lib/useSEO";

export default function ForgotPassword() {
  useSEO({ title: "Reset password", description: "Request a password reset link for your y ℶα account.", path: "/forgot-password" });
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="forgot-password-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Link to="/" className="font-display text-3xl gold-text">y ℶα</Link>
          <h1 className="font-display text-4xl mt-8 tracking-tight">Reset password.</h1>
          <p className="text-secondary-fg mt-2 text-sm">We'll send a private link to your inbox.</p>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="lux-card p-8 text-center">
            <div className="font-display text-2xl">Check your inbox</div>
            <div className="text-sm text-secondary-fg mt-3">If an account exists for <span className="text-gold">{email}</span>, a reset link has been issued. It expires in one hour.</div>
            <div className="text-xs text-muted-fg mt-6 font-mono">Demo: link is logged to backend console.</div>
            <Link to="/login" className="btn-ghost inline-block mt-8">Return to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-8">
            <div>
              <label className="text-xs uppercase tracking-[0.25em] text-muted-fg">Email</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@valiant.io" className="lux-input mt-2" />
            </div>
            <button data-testid="forgot-submit" disabled={loading} className="btn-gold w-full">
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-center text-sm text-secondary-fg">
              <Link to="/login" className="text-gold hover:text-white transition-colors">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </main>
  );
}
